/* SAGUIR — barra fija de compra en móvil (fichas de producto). */
(function () {
  var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;

  function init() {
    var btn = document.querySelector('.product-form__submit');
    if (!btn || btn.disabled) return;

    var titleEl = document.querySelector('.product__title');
    var bar = document.createElement('div');
    bar.className = 'saguir-sticky';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Compra rápida');
    bar.hidden = true;

    var info = document.createElement('div');
    info.className = 'saguir-sticky__info';
    var t = document.createElement('span');
    t.className = 'saguir-sticky__title';
    var p = document.createElement('span');
    p.className = 'saguir-sticky__price';
    info.appendChild(t);
    info.appendChild(p);

    var action = document.createElement('button');
    action.type = 'button';
    action.className = 'button button--primary saguir-sticky__btn';

    bar.appendChild(info);
    bar.appendChild(action);
    document.body.appendChild(bar);
    document.body.classList.add('saguir-has-sticky');

    function readPrice() {
      var scope = document.querySelector('.product__info-container') || document;
      var onSale = scope.querySelector('.price--on-sale .price-item--sale');
      var regular = scope.querySelector('.price-item--regular');
      var node = onSale || regular;
      return node ? node.textContent.replace(/\s+/g, ' ').trim() : '';
    }

    function refresh() {
      var current = document.querySelector('.product-form__submit');
      if (!current) return;
      t.textContent = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : document.title;
      p.textContent = readPrice();
      var label = current.querySelector('span');
      action.textContent = label ? label.textContent.replace(/\s+/g, ' ').trim() : 'Añadir';
      action.disabled = current.disabled;
    }

    action.addEventListener('click', function () {
      var current = document.querySelector('.product-form__submit');
      if (current && !current.disabled) current.click();
    });

    var visible = true;
    function update() {
      var current = document.querySelector('.product-form__submit');
      var show = !!current && !current.disabled && !visible && mq && mq.matches;
      bar.hidden = !show;
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        update();
      });
      io.observe(btn);
    }

    if ('MutationObserver' in window) {
      var pending = false;
      var mo = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () {
          pending = false;
          refresh();
          update();
        }, 150);
      });
      var container = document.querySelector('.product__info-container');
      if (container) mo.observe(container, { childList: true, subtree: true, characterData: true });
    }

    if (mq && mq.addEventListener) mq.addEventListener('change', update);
    refresh();
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
